import {ArtistModel} from "./artist.model";
import {UserTagModel} from "./user-tag.model";
import {Type} from "class-transformer";

export class ArtistsByTagModel {
  @Type(() => UserTagModel)
  tag: UserTagModel;
  @Type(() => ArtistModel)
  artists: ArtistModel[];
}
